var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('statements-search'),_vm._v(" "),_c('statements-result'),_vm._v(" "),_c('back-to-top')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }